import { render } from "./OpenCloseInfo.vue?vue&type=template&id=b6058c54&scoped=true"
import script from "./OpenCloseInfo.vue?vue&type=script&lang=js"
export * from "./OpenCloseInfo.vue?vue&type=script&lang=js"

import "./OpenCloseInfo.vue?vue&type=style&index=0&id=b6058c54&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6058c54"]])

export default __exports__